jQuery.noConflict();
(function( $ ) {
    $(function() {
        //Document Ready STARTS
        //https://api.getAddress.io/find/pr60et?api-key=vglZGNfZV0GKpR4mxkV0Fw36360
        var adr = null;
        var lookup = false;
        setTimeout(function(){
            //  checkForLookup();
        }, 1500);

        function checkForLookup(){
            var fieldID = 'adr_postcode';
            if ($('#'+fieldID).length>0) {
                $('#'+fieldID).parent().addClass('has-lookup').append('<button class="button" type="button" id="do-lookup" disabled>Search</button><div class="lookup-pop"></div>');

                $('#'+fieldID).on('input', function(){
                    var val = $(this).val();
                    if (val.length > 4) {
                        $('#do-lookup').prop('disabled', false);
                    }
                    else {
                        $('#do-lookup').prop('disabled', true);
                    }
                });

                $('body').on('click', '.close-msg', function(){
                    $('.lookup-pop').text('').removeClass('active');
                });

                $('body').on('change', '.sc-address', function(){
                    var val = $('#sc-address').val();
                    if (val != undefined && lookup != false) {
                        var data = lookup.data,
                            address = data[val];
                        if (address != undefined) {
                            var fieldsMap = {'adr_address':'line_1','town_city':'town_or_city','adr_county':'county'};
                            $.each(fieldsMap, function(k,v){
                                if ($('#'+k).length>0) {
                                    $('#'+k).val(address[v]);
                                }
                            });
                            $('.close-msg').trigger('click');
                        }
                    }
                });
            }

            $('#do-lookup').on('click', function(){
                console.log($('#'+fieldID).val());
                if( adr != null ) {
                    adr.abort();
                    adr = null;
                }

                adr = $.ajax({
                    url: ajax_url,
                    timeout: 12000,
                    type: "GET",
                    cache: false,
                    data: ({
                        action:'sc_lookup',
                        postcode: $('#'+fieldID).val(),
                    }),

                    beforeSend: function() {
                    },
                    success: function( data ) {
                        var response = decodeJSON(data);
                        console.log(response);
                        if (response.status == 'fail') {
                            $('.lookup-pop').html('<p class="alert">'+response.msg+'</p><span class="close-msg icon-cancel-circled"></span>').addClass('active');
                            setTimeout(function(){
                                $('.close-msg').trigger('click');
                            }, 3000);
                        }
                        else {
                            lookup = response;
                            var html = '<select class="sc-address" id="sc-address">';
                            var td = response.data;
                            $.each(td, function(k,v){
                                var formated = v.formatted_address,
                                    inline = formated.join(', '),
                                    name = inline.replace(/ ,/g, "");
                                html = html + '<option value="'+k+'">'+name+'</option>';
                            });
                            html = html + '</select>';
                            $('.lookup-pop').html(html+'<span class="close-msg icon-cancel-circled"></span>').addClass('active');
                            setTimeout(function(){
                                $('.sc-address').trigger('focus click open');
                            }, 1500);
                        }
                    },
                    error: function( jqXHR, textStatus, errorThrown ) {
                        console.log( 'The following error occured: ' + textStatus, errorThrown );
                    },
                    complete: function( jqXHR, textStatus ) {
                    }
                });
            });
        }


        //Document Ready ENDS
    });
})(jQuery);